"use client";

import { reportNextjsError } from "@/lib/datadog/rum";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportNextjsError(error);

    if (process.env.NODE_ENV === "development") return;

    void import("@/lib/sentry/report-global-error").then((mod) => {
      mod.reportGlobalError(error);
    });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
